<span class="badge badge-pessoa-tipo badge-pessoa-tipo-fisica">
    {{tipo.nome}}
</span>